const arrayToObject = (array) => {
    if (!array) {
        return {};
    }
    return Object.fromEntries(array.map((item) => [item.key, item.value]));
};

export { arrayToObject };
